import { Formik } from "formik";
import { Divider, Grid, TextField, FormLabel, Select, MenuItem } from "@mui/material";
import { useEffect, useState } from "react";
import { Modal } from "../../../components/common/Modal/Modal";
import { ModalHeader } from "../../../components/common/Modal/ModalHeader";
import { ModalBody } from "../../../components/common/Modal/ModalBody";
import { ModalFooter } from "../../../components/common/Modal/ModalFooter";
import CustomTable from "../../../components/common/CustomTable/CustomTable";
import { useCategoryStore } from "../../../hooks/useCategoryStore";
import { useSubcategoryStore } from "../../../hooks/useSubcategoryStore";

type Values = {
    id: number,
    name: string,
    description: string,
    idsubcategories: string,
    status: string,
}

const columns = [
    // { type: 'options', field: 'options', label: 'Acciones', align:'center' },
    { type: 'text', field: 'name', label: 'Nombre', align:'center' },
    { type: 'text', field: 'description', label: 'Descripcion', align:'center' },
    { type: 'checkbox', field: 'checkbox', label: 'checkbox', align:'center' },
];

export const CategoryModal: React.FC<any> = (props): JSX.Element | any => {

    const { open, closeModal, categorySelected, listcategories, clearState } = props;

    const { action, createCategory, editCategory } = useCategoryStore();
    const { getSubcategoriesByCompany } = useSubcategoryStore();

    const [loading, setLoading] = useState(false);
    const [loadingdata, setLoadingdata] = useState(false);
    const [subcategories, setSubcategories] = useState<any>([]);
    const [selected, setSelected] = useState<any>([]);
    const [searchTimeout, setSearchTimeout] = useState<any>(null);
    const [data, setData] = useState<Values>({
        id: categorySelected ? categorySelected.id :'',
        name: categorySelected ? categorySelected.name :'',
        description: categorySelected ? categorySelected.description :'',
        idsubcategories: categorySelected ? categorySelected.idsubcategories :'',
        status: categorySelected ? categorySelected.status :'',
    });

    useEffect(() => {
        console.log(categorySelected)
        if(categorySelected && subcategories && !searchTimeout){
            const idsubcategories = categorySelected.idsubcategories.length > 0 ? JSON.parse(categorySelected.idsubcategories) : [];
            const subcategoriesSelected = subcategories.filter(subcategory => idsubcategories.includes(subcategory.id));
            setSelected(subcategoriesSelected || []);
        }
    },[categorySelected, subcategories, !searchTimeout])

    useEffect(() => {
        getSubcategoriesByCompanyApi()
    },[])

    const getSubcategoriesByCompanyApi = async(search='') => {
        try {
            setLoadingdata(true);
            const response = await getSubcategoriesByCompany(search);
            if(!response){
                setSubcategories([]);
                setLoadingdata(false);
                return false;
            }else{
                setSubcategories(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = subcategories.map((n) => n);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };
    const onCheckbox = (row) => {
        const selectedIndex = selected.findIndex(selectedRow => selectedRow.id === row.id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, row);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };
    
    const isSelected = (row) => {
        return selected.some(item => item.id === row.id);
    };

    const onSearch = (term) => {
        clearTimeout(searchTimeout)
        setSearchTimeout(
            setTimeout(() => { getSubcategoriesByCompanyApi(term)}, 1000)
        )
    }

    const validateForm = (values) => {
        let errors:any = {};
        if(!values.name) errors.name = "el campo es requerido";
        // if(!values.description) errors.description = "el campo es requerido";
        return errors;
    }

    const onSubmit = async(values)  => {
        setLoading(true);

        const idsubcategories = selected.map(subcategory => subcategory.id);

        const formData = {
            ...values,
            idsubcategories: JSON.stringify(idsubcategories)
        }

        if(categorySelected){
            const response:any = await editCategory(categorySelected.id, formData);
            if(response){
                listcategories && listcategories();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }else{
            const response:any = await createCategory(formData);
            if(response){
                listcategories && listcategories();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }
    }

    return (
        <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick handle size="md" paperprops={{style: { position: 'absolute', right: -30, borderRadius: 20, animation: 'slide-in 0.3s ease-out', maxHeight: '100%', height: '100vh' }}}>
            <ModalHeader
                text={categorySelected ? 'Editar familia' : 'Nueva familia'}
                className='positionElements'
                onCancel={closeModal}
                clearState={clearState}
            >
            </ModalHeader>
            <ModalBody>
                <Formik initialValues={data} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={onSubmit}>
                    {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) => {
                        return (
                            <form onSubmit={handleSubmit}>
                                <Grid container sx={{padding:'20px'}}>
                                    <Grid item container xs={12} spacing={2}>

                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Nombre de la fanilia:</FormLabel>
                                            <TextField
                                                id="name"
                                                type="text" 
                                                name="name"
                                                fullWidth
                                                size="small"
                                                value={values.name}
                                                onChange={handleChange}
                                                error={errors.name && touched.name ? true : false}
                                                helperText={errors.name && touched.name ? errors.name : ''}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Descripción:</FormLabel>
                                            <TextField
                                                id="description"
                                                type="text" 
                                                name="description"
                                                fullWidth
                                                size="small"
                                                value={values.description}
                                                onChange={handleChange}
                                                error={errors.description && touched.description ? true : false}
                                                helperText={errors.description && touched.description ? errors.description : ''}
                                            />
                                        </Grid>

                                        <Grid item xs={12}>
                                            <CustomTable 
                                                disabled_title
                                                titlelabel={'Subfamilias'}
                                                columns={columns} 
                                                loading={loadingdata} 
                                                hasOptions
                                                rows={subcategories || []}
                                                onRowClick={() => {}}
                                                selectAll={handleSelectAllClick}
                                                onCheckbox={onCheckbox}
                                                isSelected={isSelected}
                                                onSearch={onSearch}
                                                RowsPerPage={5}
                                                dense
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Divider />
                                <ModalFooter 
                                    buttonType="submit"
                                    confirmText={'Guardar'}
                                    onConfirm={handleSubmit}
                                    cancelText={"Cancelar"}
                                    onCancel={closeModal}
                                    loadingConfirmText={loading}
                                    clearState={clearState}
                                />
                            </form>
                        )
                    }} 
                </Formik>
            </ModalBody>
        </Modal>
    )
}